import * as React from "react"

type ThankYouProps = {
    franchise_details: FranchiseContactDetails;
    success: boolean,
    errors?: string[];
}

export class ThankYou extends React.Component<ThankYouProps, {}> {
    render() {
        return <div>
            {
                this.props.success
                    ? <div className="thanks-page">
                        <h3>Thank you for requesting a booking</h3>
                        <p>You'll be contacted shortly by your account manager from Time For You who will check your requirements with you and arrange the home visit required to get you a cleaner started.</p>
                        <p>Please can you check all the details below are correct.</p>
                        <h3>What Happens Now?</h3>
                    <ul>
                        <li>Your account manager will be in touch to introduce themselves and book a home visit.</li>
                        <li>They confirm your requirements and payment details as per our <a href="/uk/terms-of-business.aspx">terms of business</a>.</li>
                        <li>The cleaner will contact and visit you to discuss your exact requirements and cleaning schedule.</li>
                        <li>Your home will be cleaned by your own local and vetted cleaner!</li>
                    </ul>
                    <p>If you have any queries, please contact us on: <strong><a href={this.props.franchise_details.PhoneNumberLink}>{this.props.franchise_details.PhoneNumber}</a></strong>.</p>
                    </div>
                    : <div className="thanks-page errors">
                        <h3>There was an error submitting your form.</h3>
                        <p>Please try re-submitting this form, or if you continue to have issues, please contact us on: <strong><a href={this.props.franchise_details.PhoneNumberLink}>{this.props.franchise_details.PhoneNumber}</a></strong>.</p>
                        {this.props.errors && this.props.errors.length > 0 ?
                            <>
                                <h4>The following errors were encountered:</h4>
                                <ul>
                                    {this.props.errors.map((error, index) => <li key={index}>{error}</li>)}
                                </ul>
                            </>
                        : null}
                    </div>
            }
        </div>;
    }
}